const detectLogout = () => {
  if (typeof window === 'undefined') return
  if (typeof window.inSidedData === 'undefined') {
    return
  }

  const userId = `${window.inSidedData.user.userid}`
  const storageKey = 'logout-event'
  window.localStorage.setItem(storageKey, userId)

  window.addEventListener('storage', (event) => {
    if (event.key === storageKey && event.newValue !== event.oldValue) {
      window.location.reload()
    }
  })

  // this event is triggered when using a back button
  // https://web.dev/bfcache/#update-stale-or-sensitive-data-after-bfcache-restore
  window.addEventListener('pageshow', (event) => {
    if (event.persisted && window.localStorage.getItem(storageKey) !== userId) {
      window.location.reload()
    }
  })
}

export default detectLogout
